module.exports = __webpack_public_path__ + "img/logo.70d498d1.png";